import { render, staticRenderFns } from "./refer.vue?vue&type=template&id=2a2dba91&scoped=true&"
import script from "./refer.vue?vue&type=script&lang=js&"
export * from "./refer.vue?vue&type=script&lang=js&"
import style0 from "./refer.vue?vue&type=style&index=0&id=2a2dba91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2dba91",
  null
  
)

export default component.exports